import { render } from "./ProdOrderList.vue?vue&type=template&id=3efd1052"
import script from "./ProdOrderList.vue?vue&type=script&lang=js"
export * from "./ProdOrderList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__